import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdFileDownload } from 'react-icons/md';
import { actionCreators } from '../../actions';

const Files = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('deliveries');

  const { deliveryId, errorMessage, isFetching, hasError, hasFiles, files } = useSelector(
    state => state.deliveries
  );

  useEffect(() => {
    if (!deliveryId) {
      console.warn('OrderId is null or empty in store object. Redirecting user to root...');
      navigate('/');
    } else {
      dispatch(actionCreators.getFileList(deliveryId));
    }
  }, [deliveryId, dispatch, navigate]);

  const downloadFile = (fileId) => {
    dispatch(actionCreators.getFile(fileId));
  };

  if (isFetching) {
    return <div>{t('files.loading')}</div>;
  }

  if (hasError) {
    return <div>{t('files.error')}</div>;
  }

  if (hasFiles) {
    return (
      <div className="download">
        <h1 className="h3">{t('files.header')}</h1>
        <p>{t('files.info')}</p>
        {files.map((file, index) => (
          <div className="download__list" key={index}>
            <span className="download__label" title={file.name}>{file.name}</span>
            <button 
              className="download__btn btn btn--primary" 
              onClick={() => downloadFile(file.id)}
            >
              <MdFileDownload />
            </button>
          </div>
        ))}

        {errorMessage && <span className="help-text help-text--has-error">{errorMessage}</span>}
      </div>
    );
  }

  return null;
};

export default Files;
